import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    addIdentityRegionaleRequest: ['response'],
    addIdentityRegionaleSuccess: ['loading', 'response'],
    addIdentityRegionaleFailure: ['error'],
})

export const addIdentityRegionaleTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
})

/* ------------- Reducers ------------- */

const addIdentityRegionaleRequest = state => state.merge({ success: null })

const addIdentityRegionaleSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const addIdentityRegionaleFailure = (state, { error }) => {
    console.log(error)
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.ADD_IDENTITY_REGIONALE_REQUEST]: addIdentityRegionaleRequest,
    [Types.ADD_IDENTITY_REGIONALE_SUCCESS]: addIdentityRegionaleSuccess,
    [Types.ADD_IDENTITY_REGIONALE_FAILURE]: addIdentityRegionaleFailure,
})
